import { gql } from '@apollo/client';

const referenceLogFields = gql`
  fragment referenceLogFields on ReferenceLog {
    id
    referenceEmail
    referenceSlot
    referenceResponse
    respondedAt
    user {
      data {
        id
        attributes {
          username
          firstname
          lastname
          email
          avatarUrl
        }
      }
    }
    referenceUser {
      data {
        id
        attributes {
          username
          firstname
          lastname
          email
          avatarUrl
        }
      }
    }
    createdAt
    updatedAt
  }
`;

export const getReferenceLogsByUser = gql`
  query GetReferenceLogsByUser($userId: ID!) {
    referenceLogsByUser(userId: $userId) {
      ...referenceLogFields
    }
  }
  ${referenceLogFields}
`;

export const confirmReferenceResponse = gql`
  mutation ConfirmReferenceResponse($logId: ID!, $response: Int!) {
    confirmReferenceResponse(logId: $logId, response: $response) {
      data {
        id
        attributes {
          ...referenceLogFields
        }
      }
    }
  }
  ${referenceLogFields}
`;
